import { ISearch } from './ISearch.model';
import { ActionPlanPlugin } from './action-plan-plugin.model';
import { InspectionPoint } from './inspectionPoint.model';
import { InspectionSection } from './inspectionSection.model';
import { Icon } from './icon.model';

export class ActionPlanItem implements ISearch {
  public static complete = 250;
  public id: string;
  public actionPlanId: string;
  public inspectionId: string;
  public description: string;
  public observation: string;
  public observationKey: string;
  public priority: number;
  public recommandation: string;
  public recommandationKey: string;
  public responsible: number;
  public status: number;
  public sectionId: string;
  public section: InspectionSection;
  public impacts: any[];
  public pointId: string;
  public point: InspectionPoint;
  public parentId: string;
  public pluginId: string;
  public plugins: ActionPlanPlugin[] = [];
  public icons: Icon[] = [];
  public observationPlugin: any;

  search(query: string): boolean {
    let queryToLower = query.toLowerCase();
    return (
      (this.name != null && this.name.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.observation != null && this.observation.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.recommandation != null && this.recommandation.toLowerCase().indexOf(queryToLower) !== -1)
    );
  }

  constructor(public name = 'Action Plan Item') {
    this.icons = [];
  }

  public isComplete(): boolean {
    return this.status === ActionPlanItem.complete;
  }
}
